import React, { useState } from 'react';
import { Button, Form, Upload, message, Modal } from 'antd';
import axios from 'src/core/utils/axios';
import { CloudUploadOutlined } from '@ant-design/icons';
import newAlert from 'src/components/newAlert';
import { useSelector, useDispatch } from 'react-redux';
import { start_loading, end_loading } from '../../../core/actions/loader';
import QpayModal from './qpayModal';

const FileUpload = ({ visible = true, onCancel = () => {} }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [showQpay, setShowQpay] = useState(false);
  const [paymentInfo, setPaymentInfo] = useState(null);

  const handleBeforeUpload = (file) => {
    const isPdf = file.type === 'application/pdf';
    if (!isPdf) {
      message.error(`${file.name} зөвхөн PDF файл байх ёстой`);
      return Upload.LIST_IGNORE;
    }

    const isUnder15MB = file.size / 1024 / 1024 < 15;
    if (!isUnder15MB) {
      newAlert({
        type: 'warning',
        msg: `${file.name} файлын хэмжээ 15MB-аас бага байх шаардлагатай`,
      });
      return Upload.LIST_IGNORE;
    }

    return false;
  };

  const normFile = (e) => {
    if (Array.isArray(e)) return e;
    return e && e.fileList;
  };

  const onFinish = async () => {
    dispatch(start_loading({}));
    try {
      const values = await form.validateFields();
      const fileList = values.pdfFiles;

      if (!fileList || fileList.length === 0) {
        newAlert({
          type: 'warning',
          msg: 'Файл сонгогдоогүй байна',
        });
        return;
      }

      const formData = new FormData();
      fileList.forEach((file) => {
        formData.append('pdfs', file.originFileObj);
      });

      const headers = {
        'Content-Type': 'multipart/form-data',
        jwt: localStorage.getItem('taxjwt'),
      };

      const { status, content } = await axios.post(
        'hhoat',
        '/extract-pdf',
        formData
      );
      console.log('🚀 ~ onFinish ~ status:', status);
      console.log('🚀 ~ onFinish ~ content:', content);

      if (status === 0) {
        if (content?.payment_status === 1 && content?.payment_data) {
          setPaymentInfo({ ...content.payment_data, amount: content?.amount });
          setShowQpay(true);
          onCancel(); // <-- CLOSE FileUpload Modal immediately!
          // Optionally reset the form as well:
          form.resetFields();
        } else {
          newAlert({
            type: 'success',
            msg: content?.Message || 'Амжилттай',
          });
          form.resetFields();
          onCancel();
        }
      } else {
        newAlert({
          type: 'error',
          msg: content?.Message || 'Файл илгээхэд алдаа гарлаа',
        });
      }
    } catch (error) {
      console.error('Error:', error);
      newAlert({
        type: 'error',
        msg: 'Системд алдаа гарлаа',
      });
    } finally {
      dispatch(end_loading({}));
    }
  };

  return (
    <>
      {showQpay && (
        <QpayModal
          visible={showQpay}
          onCancel={() => setShowQpay(false)}
          paymentData={paymentInfo}
          fetch={onCancel}
        />
      )}

      <Modal
        visible={visible}
        title="PDF Файлууд оруулах"
        onCancel={onCancel}
        footer={[
          <Button key="cancel" onClick={onCancel}>
            Цуцлах
          </Button>,
          <Button key="submit" type="primary" onClick={onFinish}>
            Илгээх
          </Button>,
        ]}
        destroyOnClose
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="pdfFiles"
            label="PDF файлууд сонгох"
            valuePropName="fileList"
            getValueFromEvent={normFile}
            rules={[{ required: true, message: 'PDF файл сонгоно уу' }]}
          >
            <Upload.Dragger
              accept="application/pdf"
              beforeUpload={handleBeforeUpload}
              multiple
            >
              <p className="ant-upload-drag-icon">
                <CloudUploadOutlined />
              </p>
              <p className="ant-upload-text">
                Энд дарж эсвэл PDF файлуудаа зөөж оруулна уу
              </p>
              <p className="ant-upload-hint">
                Зөвхөн PDF форматыг дэмждэг (15MB хүртэлх хэмжээтэй)
              </p>
            </Upload.Dragger>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default FileUpload;
